import {MessageCodes} from "../MessageCodes";
import ResultText from "../ResultText";
import EmptyLine from "../EmptyLine";
import {useUser} from "../../../context/UserContext";
import ResultView from "../../../components/ResultView";
import CheckCSName from "../CheckCSName";

export function B16({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const Description = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Internal.BCF01.error_id: {
            return (
                <>
                    <ResultText>
                        {
                            row?.data?.map(r => (
                                <ResultText>
                                    The {r?.type}{r?.number ? `#${r.number}` : ''} at RS {<CheckCSName csName={r?.cross_section} />} does not fit between the bounding cross sections.
                                    <EmptyLine />
                                </ResultText>
                            ))
                        }
                    </ResultText>
                </>
            )
        }
    }
}